<template>
	<div class="detial-wrapper">
		<el-tabs v-model="activeTabIndex">
			<el-tab-pane
				v-for="(item, index) in diagnosisData"
				:key="`tabPane-${index}`"
				:label="item.ZZMC"
				:name="String(index)"
			></el-tab-pane>
		</el-tabs>

		<!-- 诊断结果表格 -->
		<div class="diag-table">
			<table>
				<thead>
					<tr class="type-header">
						<th class="item-name" colspan="2" rowspan="2">类型</th>
						<th class="existing-header">现有</th>
						<th class="standard-header">标准要求</th>
						<th class="result-header">结果</th>
					</tr>
				</thead>
				<tbody>
					<!-- 动态生成行 -->
					<!-- 动态生成行 -->
					<template v-for="(rowGroup, groupIndex) in groupedRows">
						<template v-for="(rowType, rowIndex) in rowGroup.rows">
							<tr :key="`row-${groupIndex}-${rowIndex}`">
								<!-- 如果资质名称和类型名称相同则合并单元格列 -->
								<template v-if="rowType.ZZMC === rowType.TYPE">
									<td :colspan="rowType.ZZMC === rowType.TYPE ? 2 : 1" :rowspan="rowGroup.rowspan" class="item-type br">
										{{ rowType.TYPE }}
									</td>
								</template>
								<template v-else-if="rowIndex === 0">
									<td :rowspan="rowGroup.rowspan" class="item-name">{{ rowType.ZZMC }}</td>
									<td class="item-type br">{{ rowType.TYPE }}</td>
								</template>
								<template v-else>
									<td class="item-type br">{{ rowType.TYPE }}</td>
								</template>

								<template v-for="(item, colIndex) in diagnosisData">
									<template v-if="getOptionByType(diagnosisData[activeTabIndex].RESULT, rowType.TYPE)">
										<td :key="`cell-existing-${groupIndex}-${rowIndex}-${colIndex}`" class="existing-value">
											{{ getOptionByType(diagnosisData[activeTabIndex].RESULT, rowType.TYPE).EXISTING }}
										</td>
										<td :key="`cell-standard-${groupIndex}-${rowIndex}-${colIndex}`" class="standard-value">
											{{ getOptionByType(diagnosisData[activeTabIndex].RESULT, rowType.TYPE).STANDARD }}
										</td>
										<td
											:key="`cell-result-${groupIndex}-${rowIndex}-${colIndex}`"
											:class="[
												'result-value',
												getOptionByType(diagnosisData[activeTabIndex].RESULT, rowType.TYPE).WHETHER ? 'success' : 'error'
											]"
										>
											{{ getOptionByType(diagnosisData[activeTabIndex].RESULT, rowType.TYPE).RESULTS }}
										</td>
									</template>
									<template v-else>
										<td :key="`cell-empty1-${groupIndex}-${rowIndex}-${colIndex}`">-</td>
										<td :key="`cell-empty2-${groupIndex}-${rowIndex}-${colIndex}`">-</td>
										<td :key="`cell-empty3-${groupIndex}-${rowIndex}-${colIndex}`">-</td>
									</template>
								</template>
							</tr>
						</template>
					</template>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import { getDiagnosisRecordDetail } from '@/api/certTreasure/diagnosis'

	// 安许诊断结果比对详情
	export default {
		name: 'SafetyPermitMaintenanceDiagnosisResultDetail',
		components: {},
		props: {
			// 诊断记录id
			recordId: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				// 添加当前激活的tab索引
				activeTabIndex: 0,
				// 诊断结果数据
				diagnosisData: []
			}
		},
		computed: {
			// 计算需要合并的行数
			groupedRows() {
				const uniqueTypes = this.getUniqueTypes()
				const grouped = {}
				uniqueTypes.forEach(type => {
					if (!grouped[type.ZZMC]) {
						grouped[type.ZZMC] = { rows: [], rowspan: 0 }
					}
					grouped[type.ZZMC].rows.push(type)
					grouped[type.ZZMC].rowspan++
				})
				return Object.values(grouped)
			}
		},
		watch: {},
		created() {},
		mounted() {
			this.handleQueryRecordDetail()
		},
		methods: {
			// 查询诊断结果对比json
			handleQueryRecordDetail() {
				const params = {
					recordId: this.recordId
				}

				getDiagnosisRecordDetail(params).then(response => {
					const { data } = response

					if (data && data.diagnosisInfo) {
						const diagnosisResultData = JSON.parse(data.diagnosisInfo)
						// 安许的资质对比结果需要额外处理，在第一层把资质名称添加上
						diagnosisResultData[0].ZZMC = '建筑施工企业安全生产许可证'
						diagnosisResultData[0].ZZCODE = '10901'
						console.log('diagnosisResultData:', diagnosisResultData)

						this.diagnosisData = diagnosisResultData
					}
				})
			},

			// 获取所有唯一的类型，用于生成表格行
			getUniqueTypes() {
				const types = []
				this.diagnosisData.forEach(item => {
					item.RESULT.forEach(option => {
						// types.add(option.TYPE)
						types.push({
							TYPE: option.TYPE,
							ZZMC: option.ZZMC
						})
					})
				})
				return types
			},

			// 根据类型获取对应的选项
			getOptionByType(options, type) {
				return options.find(option => option.TYPE === type)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../styles/diagnosisTable.scss';

	::v-deep {
		.el-tabs__header {
			margin-bottom: 20px;
			border-bottom: 1px solid #e4e7ed;
		}

		.el-tabs__nav-wrap::after {
			display: none; /* 移除默认底部线条 */
		}

		.el-tabs__item {
			padding: 10px 20px;
			// margin-right: 10px;
			font-size: 16px;
			color: #606266;
			transition: all 0.3s;
			height: auto;
			line-height: 1.5;

			&.is-active {
				color: #236fca;
				font-weight: 500;
			}

			&:hover {
				color: #236fca;
			}
		}

		.el-tabs__active-bar {
			background-color: #236fca;
			height: 2px;
		}
	}
</style>
